// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"5925f556","43":"97fc9384","90":"75f310d4","498":"ba3c9375","863":"97fc9384"}[chunkId] + ".chunk.css";
};